import {memo} from 'react'
import _ from 'lodash'
import {useFloatingSelectContext, useSelectContext} from '../../context'
import {SelectItemDot} from '../select_item_dot'
import {Text} from '~/components/text'
import {Layout} from '~/components/layout'
import {CollapseChevron} from '~/components/collapse_chevron'
import {Checkbox, CosmeticCheckbox} from '~/components/checkbox'

export const SelectItemLayout = memo(
	({item, originalIndex, showChevron, isExpanded, bold, countSuffix, height = 40, ItemComponent, checkboxProps, children, ...rest}) => {
		const {virtualized} = useSelectContext()
		const {listRef} = useFloatingSelectContext()

		const selectItemRef = node => {
			if (listRef && _.isNumber(originalIndex) && node) {
				listRef.current[originalIndex] = node
			}
		}

		const skipHeight = !virtualized && ItemComponent

		return (
			<Layout
				ref={selectItemRef}
				className="select-item"
				colorSet
				padding="8 16"
				gap={8}
				width="full"
				height={!skipHeight && height}
				{...rest}
			>
				{ItemComponent && <ItemComponent item={item} checkboxProps={checkboxProps} />}
				{!ItemComponent && (
					<SelectItemContent showChevron={showChevron} isExpanded={isExpanded} checkboxProps={checkboxProps}>
						<SelectItemDot dotColor={item?.dotColor} />
						<Text
							t={item?.t}
							bold={bold}
							countSuffix={countSuffix}
							style={{flex: 1}}
							noTextSelect
							truncate
							infoIconMessage={item?.infoIconMessage}
						>
							{children}
						</Text>
					</SelectItemContent>
				)}
			</Layout>
		)
	},
)

// This component can be used in custom a ItemComponent, to keep the checkbox and chevron functionality if desired
export const SelectItemContent = ({showChevron, isExpanded, children, checkboxProps}) => {
	return (
		<>
			{checkboxProps?.onChange && (
				<Checkbox
					checked={checkboxProps.indeterminate ? 'indeterminate' : checkboxProps.checked}
					onChange={checkboxProps.onChange}
					onClick={event => event.stopPropagation()}
					disabled={checkboxProps.disabled}
				/>
			)}
			{checkboxProps && !checkboxProps.onChange && (
				<CosmeticCheckbox
					checked={checkboxProps.indeterminate ? 'indeterminate' : checkboxProps.checked}
					disabled={checkboxProps.disabled}
				/>
			)}
			{children}
			{showChevron && <CollapseChevron open={isExpanded} />}
		</>
	)
}
